var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "systemTempModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.isEdit ? "编辑系统消息模板" : "新增系统消息模板",
            top: "80px",
            width: "920px",
            "destroy-on-close": "",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.pram,
                rules: _vm.rules,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模板KEY：", prop: "templateKey" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isEdit,
                      clearable: "",
                      placeholder: "例如：order_paid",
                    },
                    model: {
                      value: _vm.pram.templateKey,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "templateKey", $$v)
                      },
                      expression: "pram.templateKey",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v("对应后端枚举 "),
                    _c("code", [_vm._v("SystemMessageTemplateEnum")]),
                    _vm._v("，创建后不可修改"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "模板名称：", prop: "templateName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入模板名称" },
                    model: {
                      value: _vm.pram.templateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "templateName", $$v)
                      },
                      expression: "pram.templateName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "描述：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      resize: "none",
                      placeholder: "请输入描述",
                    },
                    model: {
                      value: _vm.pram.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "description", $$v)
                      },
                      expression: "pram.description",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "通知级别：" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        clearable: "",
                        placeholder: "请选择通知级别（非必填）",
                      },
                      model: {
                        value: _vm.pram.alertLevel,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "alertLevel", $$v)
                        },
                        expression: "pram.alertLevel",
                      },
                    },
                    _vm._l(_vm.alertLevelList, function (level) {
                      return _c(
                        "el-option",
                        {
                          key: level.code,
                          attrs: { label: level.name, value: level.code },
                        },
                        [
                          _c(
                            "span",
                            {
                              style: {
                                color: level.highlight ? "#F56C6C" : "#606266",
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(level.name) +
                                  " - " +
                                  _vm._s(level.description) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "tip" }, [
                    _vm._v(
                      "设置通知级别后，消息标题将显示对应级别标识，P0/P1将标红"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-divider",
                { attrs: { "content-position": "left" } },
                [
                  _vm._v(
                    "\n                通知渠道配置（拖动Tab调整顺序，越靠前优先级越高）\n                "
                  ),
                  _c("el-tooltip", { attrs: { placement: "top" } }, [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _vm._v("同一变量名在模板中重复出现时将统一替换。"),
                      _c("br"),
                      _vm._v("启用但模板内容为空时该渠道将被跳过。"),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "tip-icon" }, [
                      _c("i", { staticClass: "el-icon-question" }),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "channel-tabs-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "tabs-header-wrapper" },
                  [
                    _c(
                      "draggable",
                      {
                        staticClass: "tabs-header",
                        attrs: {
                          list: _vm.channelList,
                          animation: 150,
                          tag: "div",
                          handle: ".tab-drag-handle",
                          "ghost-class": "tab-ghost",
                          "chosen-class": "tab-chosen",
                          direction: "horizontal",
                          "force-fallback": true,
                          "fallback-class": "tab-fallback",
                        },
                        on: {
                          start: _vm.onTabSortStart,
                          end: _vm.onTabSortEnd,
                        },
                      },
                      _vm._l(_vm.channelList, function (channel) {
                        return _c(
                          "div",
                          {
                            key: channel.channelCode,
                            class: [
                              "tabs-header-item",
                              {
                                "is-active":
                                  _vm.activeTab === channel.channelCode,
                                "is-disabled": channel.enabled === 0,
                              },
                            ],
                          },
                          [
                            _c("i", {
                              staticClass: "el-icon-rank tab-drag-handle",
                              attrs: { title: "拖动排序" },
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "tab-name tab-clickable",
                                on: {
                                  click: function ($event) {
                                    _vm.activeTab = channel.channelCode
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.getChannelName(channel.channelCode)
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("el-switch", {
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                size: "mini",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onEnabledChange(channel)
                                },
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                },
                              },
                              model: {
                                value: channel.enabled,
                                callback: function ($$v) {
                                  _vm.$set(channel, "enabled", $$v)
                                },
                                expression: "channel.enabled",
                              },
                            }),
                            _vm._v(" "),
                            channel.enabled === 0
                              ? _c(
                                  "span",
                                  { staticClass: "tab-disabled-tip" },
                                  [_vm._v("已关闭")]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "tabs-content-wrapper" }, [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "feishu",
                          expression: "activeTab === 'feishu'",
                        },
                      ],
                      staticClass: "tab-pane-content",
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "标题：", "label-width": "100px" } },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.getTitle(_vm.getChannel("feishu")),
                              clearable: "",
                              placeholder: "飞书通知标题",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setTitle(_vm.getChannel("feishu"), $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型：", "label-width": "100px" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                value: _vm.getType(_vm.getChannel("feishu")),
                              },
                              on: {
                                input: function ($event) {
                                  _vm.setType(_vm.getChannel("feishu"), $event)
                                },
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "group" } }, [
                                _vm._v("飞书群"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "person" } }, [
                                _vm._v("个人通知"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.getType(_vm.getChannel("feishu")) === "group"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "webhook：",
                                "label-width": "100px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  value: _vm.getWebhook(
                                    _vm.getChannel("feishu")
                                  ),
                                  clearable: "",
                                  placeholder: "不填则使用默认webhook地址",
                                },
                                on: {
                                  input: function ($event) {
                                    _vm.setWebhook(
                                      _vm.getChannel("feishu"),
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "通知人：", "label-width": "100px" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                value: _vm.getAdminIds(
                                  _vm.getChannel("feishu")
                                ),
                                multiple: "",
                                filterable: "",
                                clearable: "",
                                placeholder: "选择管理员（支持多选）",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.setAdminIds(
                                    _vm.getChannel("feishu"),
                                    $event
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.adminList, function (admin) {
                              return _c("el-option", {
                                key: admin.id,
                                attrs: {
                                  label:
                                    admin.realName +
                                    "（" +
                                    (admin.phone || "无手机号") +
                                    "）",
                                  value: admin.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "模板内容：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "variable-bar" },
                            [
                              _c("span", { staticClass: "bar-label" }, [
                                _vm._v("变量选择："),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.variableList, function (v) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: v.key,
                                    staticClass: "variable-tag",
                                    attrs: { size: "mini", effect: "plain" },
                                    on: {
                                      click: function ($event) {
                                        _vm.appendVariable(
                                          _vm.getChannel("feishu"),
                                          v.name
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(v.name) +
                                        "\n                                "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            ref: "textarea_feishu",
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              resize: "none",
                              placeholder:
                                "请输入飞书模板内容，使用 {变量名} 引用变量",
                            },
                            model: {
                              value: _vm.getChannel("feishu").content,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.getChannel("feishu"),
                                  "content",
                                  $$v
                                )
                              },
                              expression: "getChannel('feishu').content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "sms",
                          expression: "activeTab === 'sms'",
                        },
                      ],
                      staticClass: "tab-pane-content",
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "通知管理员：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                value: _vm.getSmsAdminIds(
                                  _vm.getChannel("sms")
                                ),
                                multiple: "",
                                filterable: "",
                                clearable: "",
                                placeholder: "选择管理员（支持多选）",
                              },
                              on: {
                                input: function ($event) {
                                  _vm.setSmsAdminIds(
                                    _vm.getChannel("sms"),
                                    $event
                                  )
                                },
                              },
                            },
                            _vm._l(_vm.adminList, function (admin) {
                              return _c("el-option", {
                                key: admin.id,
                                attrs: {
                                  label:
                                    admin.realName +
                                    "（" +
                                    (admin.phone || "无手机号") +
                                    "）",
                                  value: admin.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "其他电话：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.getSmsOtherPhones(
                                _vm.getChannel("sms")
                              ),
                              clearable: "",
                              placeholder: "多个手机号以英文逗号分隔",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setSmsOtherPhones(
                                  _vm.getChannel("sms"),
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "短信服务商：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                value: _vm.getSmsProvider(
                                  _vm.getChannel("sms")
                                ),
                              },
                              on: {
                                input: function ($event) {
                                  _vm.setSmsProvider(
                                    _vm.getChannel("sms"),
                                    $event
                                  )
                                },
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "TENCENT" } }, [
                                _vm._v("腾讯云"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "ALIYUN" } }, [
                                _vm._v("阿里云"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "腾讯模板Code：",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.getSmsTencentTemplateCode(
                                _vm.getChannel("sms")
                              ),
                              clearable: "",
                              placeholder: "请输入腾讯云短信模板Code",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setSmsTencentTemplateCode(
                                  _vm.getChannel("sms"),
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { "label-width": "130px" } },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _vm._v(
                                "\n                                腾讯模板内容：\n                                "
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "腾讯云按模板内容中变量的出现顺序填充参数",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-question tip-icon",
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "variable-bar" },
                            [
                              _c("span", { staticClass: "bar-label" }, [
                                _vm._v("变量选择："),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.variableList, function (v) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: v.key,
                                    staticClass: "variable-tag",
                                    attrs: {
                                      size: "mini",
                                      effect: "plain",
                                      title: "点击插入 {" + v.key + "}",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.appendVariable(
                                          _vm.getChannel("sms"),
                                          v.key
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(v.name) +
                                        "（" +
                                        _vm._s(v.key) +
                                        "）\n                                "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            ref: "textarea_sms",
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              resize: "none",
                              placeholder:
                                "请输入腾讯云模板内容，使用 {orderNo} 等系统变量",
                            },
                            model: {
                              value: _vm.getChannel("sms").content,
                              callback: function ($$v) {
                                _vm.$set(_vm.getChannel("sms"), "content", $$v)
                              },
                              expression: "getChannel('sms').content",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tip" }, [
                            _vm._v(
                              "点击上方变量会插入英文占位符，腾讯云按变量出现顺序填充；历史中文占位符仍然兼容。"
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "阿里模板Code：",
                            "label-width": "120px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.getSmsAliyunTemplateCode(
                                _vm.getChannel("sms")
                              ),
                              clearable: "",
                              placeholder: "请输入阿里云短信模板Code",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setSmsAliyunTemplateCode(
                                  _vm.getChannel("sms"),
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "阿里模板内容：",
                            "label-width": "130px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "variable-bar" },
                            [
                              _c("span", { staticClass: "bar-label" }, [
                                _vm._v("变量选择："),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.variableList, function (v) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: v.key,
                                    staticClass: "variable-tag",
                                    attrs: {
                                      size: "mini",
                                      effect: "plain",
                                      title: "点击插入 ${" + v.key + "}",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.appendAliyunVariable(
                                          _vm.getChannel("sms"),
                                          v.key
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(v.name) +
                                        "（" +
                                        _vm._s(v.key) +
                                        "）\n                                "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              value: _vm.getSmsAliyunTemplateContent(
                                _vm.getChannel("sms")
                              ),
                              type: "textarea",
                              rows: 6,
                              resize: "none",
                              placeholder:
                                "请输入阿里云模板内容，例如：订单${orderNo}已支付",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setSmsAliyunTemplateContent(
                                  _vm.getChannel("sms"),
                                  $event
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tip" }, [
                            _vm._v(
                              "请与阿里云后台模板保持一致，变量使用 ${英文变量名} 格式。"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "wechat",
                          expression: "activeTab === 'wechat'",
                        },
                      ],
                      staticClass: "tab-pane-content",
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "微信名称：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.getWechatNames(
                                _vm.getChannel("wechat")
                              ),
                              clearable: "",
                              placeholder: "多个以逗号分隔",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setWechatNames(
                                  _vm.getChannel("wechat"),
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "群组名称：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.getWechatGroupNames(
                                _vm.getChannel("wechat")
                              ),
                              clearable: "",
                              placeholder: "多个以逗号分隔",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setWechatGroupNames(
                                  _vm.getChannel("wechat"),
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "模板内容：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "variable-bar" },
                            [
                              _c("span", { staticClass: "bar-label" }, [
                                _vm._v("变量选择："),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.variableList, function (v) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: v.key,
                                    staticClass: "variable-tag",
                                    attrs: { size: "mini", effect: "plain" },
                                    on: {
                                      click: function ($event) {
                                        _vm.appendVariable(
                                          _vm.getChannel("wechat"),
                                          v.name
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(v.name) +
                                        "\n                                "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            ref: "textarea_wechat",
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              resize: "none",
                              placeholder:
                                "请输入微信模板内容，使用 {变量名} 引用变量",
                            },
                            model: {
                              value: _vm.getChannel("wechat").content,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.getChannel("wechat"),
                                  "content",
                                  $$v
                                )
                              },
                              expression: "getChannel('wechat').content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.activeTab === "email",
                          expression: "activeTab === 'email'",
                        },
                      ],
                      staticClass: "tab-pane-content",
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "邮件主题：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.getEmailSubject(
                                _vm.getChannel("email")
                              ),
                              clearable: "",
                              placeholder: "邮件主题",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setEmailSubject(
                                  _vm.getChannel("email"),
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "通知人：", "label-width": "100px" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              value: _vm.getEmailNotifyUsers(
                                _vm.getChannel("email")
                              ),
                              clearable: "",
                              placeholder: "多个以逗号分隔，非必填",
                            },
                            on: {
                              input: function ($event) {
                                _vm.setEmailNotifyUsers(
                                  _vm.getChannel("email"),
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "模板内容：",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "variable-bar" },
                            [
                              _c("span", { staticClass: "bar-label" }, [
                                _vm._v("变量选择："),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.variableList, function (v) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: v.key,
                                    staticClass: "variable-tag",
                                    attrs: { size: "mini", effect: "plain" },
                                    on: {
                                      click: function ($event) {
                                        _vm.appendVariable(
                                          _vm.getChannel("email"),
                                          v.name
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(v.name) +
                                        "\n                                "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            ref: "textarea_email",
                            attrs: {
                              type: "textarea",
                              rows: 6,
                              resize: "none",
                              placeholder:
                                "请输入邮件模板内容，使用 {变量名} 引用变量",
                            },
                            model: {
                              value: _vm.getChannel("email").content,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.getChannel("email"),
                                  "content",
                                  $$v
                                )
                              },
                              expression: "getChannel('email').content",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }